import type { PostFilter } from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import { ItemGridFilterBoolean } from "../ItemGridFilter/ItemGridFilterBoolean";

type SupportedFilter = PostFilter | null | undefined;

export function ItemGridFilterEnabled() {
  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithEnabled: SupportedFilter = filter;

  return (
    <ItemGridFilterBoolean
      checked={filterWithEnabled?.enabled ?? undefined}
      property="enabled"
      text="Enabled"
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.enabled;
          }
        })
      }
      onRequestFilterUpdate={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (filterWithEnabled?.enabled === true) {
              draft.enabled = false;
            } else if (filterWithEnabled?.enabled === false) {
              delete draft.enabled;
            } else {
              draft.enabled = true;
            }
          }
        })
      }
    />
  );
}
